"use client";
import { valibotResolver } from "@hookform/resolvers/valibot";
import { useAction } from "next-safe-action/hooks";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { PrimaryButton } from "ui/components";
import { Input } from "ui/inputs";
import type { loginAction } from "./login-action";
import { type LoginData, LoginSchema } from "./login-schema";

type Props = {
  redirectUrl: string;
  loginAction: typeof loginAction;
};
export const LoginForm = ({ redirectUrl, loginAction }: Props) => {
  const router = useRouter();
  const { control, handleSubmit, setError } = useForm<LoginData>({
    resolver: valibotResolver(LoginSchema),
    defaultValues: {
      username: "",
      password: "",
    } satisfies LoginData,
  });
  const { execute, status } = useAction(loginAction, {
    onError: () => {
      setError("password", {
        message: "Identifiant invalide",
      });
    },
    onSuccess: () => router.push(redirectUrl),
  });

  return (
    <form className="grid grid-cols-1 gap-2 w-80 bg-white rounded-sm p-6 space-y-6" onSubmit={handleSubmit(execute)}>
      <Input
        id="username"
        name="username"
        control={control}
        label="Nom d'utilisateur *"
        placeholder="Nom d'utilisateur"
      />
      <Input
        id="password"
        name="password"
        control={control}
        label="Mot de passe *"
        placeholder="Mot de passe"
        type="password"
      />
      <PrimaryButton type="submit" disabled={status === "executing"}>
        Se connecter
      </PrimaryButton>
    </form>
  );
};
